export const enum EPaymentType {
  Payment = 'payment',
  Return = 'refund',
}
